/**
 * Standard GA4 eCommerce Data Layer for GTM.
 * Pushes add_to_cart, begin_checkout, and purchase with product details,
 * prices, and currency.
 */

const CURRENCY = "USD";
const PURCHASE_DONE_PREFIX = "igniterx_gtm_purchase_";

function toNumber(value) {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : 0;
}

function mapItems(products, discountPercent, discountAmount) {
  const list = Array.isArray(products) ? products.filter(Boolean) : [];
  const percent = toNumber(discountPercent);
  const amount = toNumber(discountAmount);
  const usePercent = percent > 0;

  return list.map((product, index) => {
    const originalPrice = toNumber(product.product_price);
    let price = originalPrice;
    let discount = 0;

    if (usePercent) {
      discount = (originalPrice * percent) / 100;
      price = originalPrice - discount;
    } else if (amount > 0 && list.length > 0) {
      discount = amount / list.length;
      price = originalPrice - discount;
    }

    return {
      item_id: String(product.product_id || ""),
      item_name: product.product_name || "",
      price: Number(price.toFixed(2)),
      discount: Number(discount.toFixed(2)),
      quantity: 1,
      index,
    };
  });
}

function itemsValue(items) {
  return Number(
    items
      .reduce((sum, item) => sum + toNumber(item.price) * (item.quantity || 1), 0)
      .toFixed(2)
  );
}

function pushEcommerceEvent(event, ecommerce) {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });
  window.dataLayer.push({
    event,
    ecommerce,
  });
}

export function pushAddToCart(products) {
  const items = mapItems(products);
  if (!items.length) return;
  pushEcommerceEvent("add_to_cart", {
    currency: CURRENCY,
    value: itemsValue(items),
    items,
  });
}

export function pushBeginCheckout(products) {
  const items = mapItems(products);
  if (!items.length) return;
  pushEcommerceEvent("begin_checkout", {
    currency: CURRENCY,
    value: itemsValue(items),
    items,
  });
}

export function pushPurchase({
  products,
  transactionId,
  value,
  coupon,
  discountPercent,
  discountAmount,
}) {
  const id = transactionId != null ? String(transactionId) : "";
  if (!id) return;

  try {
    if (sessionStorage.getItem(PURCHASE_DONE_PREFIX + id) === "1") return;
  } catch {
    /* ignore */
  }

  const items = mapItems(products, discountPercent, discountAmount);
  const ecommerce = {
    transaction_id: id,
    currency: CURRENCY,
    value: Number(toNumber(value).toFixed(2)),
    items,
  };
  if (coupon) ecommerce.coupon = String(coupon);

  pushEcommerceEvent("purchase", ecommerce);

  try {
    sessionStorage.setItem(PURCHASE_DONE_PREFIX + id, "1");
  } catch {
    /* ignore */
  }
}
